import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import moment from 'moment';

@Injectable({ providedIn: 'root' })
export class TokenService {


	constructor(private jwtHelper: JwtHelperService) { }

	checkTokenValid(token: any): boolean {
		try {
			const data = this.jwtHelper.decodeToken(token);
			return moment().isBefore(this.getTokenExpiry(data));
    } catch (error) {
      return false;
    }
  }

  getTokenExpiry(token: any): any {
		return moment.unix(token.exp);
  }

	getTokenExp(token: any): string {
    const tokenDetails = this.jwtHelper.decodeToken(token);
    return tokenDetails.exp;
  }
}